/**
 * Builds the `submitOne` broker POST closure for the Complex-Login fan-out
 * (`submitComplexLoginIdentities`). Shared with the seed-wizard host's
 * equivalent pattern and imported by tests so they exercise the REAL closure
 * instead of duplicating it.
 */

import { type AxiosInstance } from 'axios';

import {
  type BrokerPayloadBody,
  type CredentialIdentity,
} from '@/sections/asset/components/tabs/credentials/credentialForms';
import { readConversationId } from '@/sections/asset/components/tabs/credentials/readConversationId';

export function makeComplexLoginSubmitOne(
  axios: AxiosInstance,
  assetKey: string
): (
  brokerPayload: BrokerPayloadBody,
  identity: CredentialIdentity
) => Promise<{ conversationId?: string }> {
  return async brokerPayload => {
    const response = await axios.post(`/broker`, {
      Category: 'env-integration',
      Operation: 'add',
      ResourceKey: assetKey, // already '#webapplication#<url>' — no URL construction
      ...brokerPayload,
    });
    return { conversationId: readConversationId(response.data) ?? undefined };
  };
}
